import React, { FC, useState } from "react";
import EditedWorkAdd from "./EditedWorkAdd";
import EditedWorksListComponent from "./EditedWorkListComponent";
import { BlackButton } from "../../../styles/styledcomponets";
import EditedWorkDetails from "./EditedWorkDetails";

enum States {
  LISTING = 0,
  ADDING = 1,
  EDITING = 2
}

const EditedWorksCMSLayout: FC = () => {
  const [state, setState] = useState<States>(States.LISTING);
  const [workID, setWorkID] = useState<string | undefined>(undefined);

  const workSaved = () => {
    setState(States.LISTING);
  };

  const selectWorkToEdit = (id: string, state: States): void => {
    setWorkID(id);
    setState(state);
  };

  return (
    <React.Fragment>
      {state === States.LISTING && (
        <>
          <BlackButton onClick={() => setState(States.ADDING)}>
            Add new work
          </BlackButton>
          <EditedWorksListComponent workIDHandler={selectWorkToEdit} />
          <BlackButton onClick={() => setState(States.ADDING)}>
            Add new work
          </BlackButton>
        </>
      )}

      {[States.ADDING, States.EDITING].includes(state) && (
        <BlackButton onClick={() => setState(States.LISTING)}>
          Go back to works list
        </BlackButton>
      )}

      {state === States.ADDING && <EditedWorkAdd workSaved={workSaved} />}
      {state === States.EDITING && workID && <EditedWorkDetails id={workID} />}

      {[States.ADDING, States.EDITING].includes(state) && (
        <BlackButton onClick={() => setState(States.LISTING)}>
          Go back to works list
        </BlackButton>
      )}
    </React.Fragment>
  );
};

export default EditedWorksCMSLayout;
